import { useQuery } from '@tanstack/react-query';
import { updateSelicRates, getObraValoresCorrigidos, Obra } from '../services/api';



export const useValoresCorrigidos = (obra: Obra | null, balanco: any | null) => {
    const {
        data: valoresCorrigidos,
        isLoading: loading,
        error,
        refetch
    } = useQuery({
        queryKey: ['valores-corrigidos', obra?.id],
        queryFn: async () => {
            if (!obra) return null;
            // Ensure SELIC rates are up to date
            await updateSelicRates();
            // Calculate corrected values
            return getObraValoresCorrigidos(
                obra.id,
                obra.data_limite_correcao || obra.data_termino_prevista
            );
        },
        enabled: !!obra && !!balanco,
        retry: 2,
    });

    return {
        valoresCorrigidos,
        loading,
        error: error ? (error as Error).message : null,
        recalculate: refetch
    };
};
